<div *ngIf="auth && auth.user">
  <div class="search-form">
    <button mat-raised-button color="primary" (click)="search()" class="report-btn"> <mat-icon>search</mat-icon> </button>
  </div>
  <div *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="langId">
        <th mat-header-cell *matHeaderCellDef> Language Id </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.langId}} </td>
      </ng-container>
      <ng-container matColumnDef="signatureError">
        <th mat-header-cell *matHeaderCellDef> Signature Error </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.signatureError}} </td>
      </ng-container>

      <ng-container matColumnDef="signatureHeader">
        <th mat-header-cell *matHeaderCellDef> Signature Header </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.signatureHeader}} </td>
      </ng-container>
      <ng-container matColumnDef="termsHeader">
        <th mat-header-cell *matHeaderCellDef> Terms Header </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.termsHeader}} </td>
      </ng-container>
      <ng-container matColumnDef="termsText">
        <th mat-header-cell *matHeaderCellDef> Terms Text </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.termsText}} </td>
      </ng-container>
      <ng-container matColumnDef="gdprHeader">
        <th mat-header-cell *matHeaderCellDef> GDPR Header </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.gdprHeader}} </td>
      </ng-container>
      <ng-container matColumnDef="gdprText">
        <th mat-header-cell *matHeaderCellDef> GDPR Text </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.gdprText}} </td>
      </ng-container>


      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.name}} </td>
      </ng-container>
  
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef> Last Name </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.lastName}} </td>
      </ng-container>
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef> Country </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.country}} </td>
      </ng-container>
    
      <ng-container matColumnDef="male">
        <th mat-header-cell *matHeaderCellDef> Male </th>
        <td mat-cell *matCellDef="let element"> {{element.male}} </td>
      </ng-container>

      <ng-container matColumnDef="female">
        <th mat-header-cell *matHeaderCellDef> Female </th>
        <td mat-cell *matCellDef="let element"> {{element.female}} </td>
      </ng-container>

      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef> Age </th>
        <td mat-cell *matCellDef="let element"> {{element.age}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.email}} </td>
      </ng-container>

      <ng-container matColumnDef="idPassport">
        <th mat-header-cell *matHeaderCellDef> Id Passport </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.idPassport}} </td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef> Marketing Channel </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.source}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"  (click)="showDetails(row)"></tr>
    </table>
  </div>
</div>